import { NUMBER_SIZE } from '../../../../../../../constants/size'
import { FileIconPreview } from '../../../../../../FileIcon'
import { TableCellEmpty } from '../../../../../../Table'
import Text from '../../../../../../Text'

import * as styles from './ApplicantDocumentChecklistFileCell.module.css'

function ApplicantDocumentChecklistFileCell({ file, onClickFile }) {
  function handleClickFile() {
    onClickFile(file?.id)
  }

  return file ? (
    <div
      className={styles.ApplicantDocumentChecklistFileCell}
      onClick={handleClickFile}
    >
      <FileIconPreview file={file} size={NUMBER_SIZE.size24} />
      <Text isSecondary className={styles.name}>
        {file.filename || file.name}
      </Text>
    </div>
  ) : (
    <TableCellEmpty className={styles.empty} />
  )
}

export default ApplicantDocumentChecklistFileCell
